import PaymentsForSubscriptionDatagrid from 'src/components/DatagridEntity/PaymentsForSubscriptionDatagrid';

const PaymentsSubscriptionPage = () => (<PaymentsForSubscriptionDatagrid />);
export default PaymentsSubscriptionPage;
